import { render, staticRenderFns } from "./Ver.vue?vue&type=template&id=a075af4c&"
import script from "./Ver.vue?vue&type=script&lang=js&"
export * from "./Ver.vue?vue&type=script&lang=js&"
import style0 from "./Ver.vue?vue&type=style&index=0&id=a075af4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports